import React from 'react';
import { DateRange } from 'react-day-picker';

import { CustomSearchInputClassList } from 'component/Search/Input/types';

import { BackendConfig } from 'types/Search/form';

export interface DatepickerProps {
    formType: FormType;
    holidays: Date[];
    vacations: Date[];
    config: BackendConfig;
    initiallyOpenDatepicker?: DatepickerType;
    dateRange?: DateRange;
    label?: string[];
    placeholder: string[];
    customClassList?: CustomSearchInputClassList;
    callback: DatePickerCallbackInterface;
    type: DatepickerType;
}

export interface DatePickerCallbackInterface {
    onClose?: () => void;
    onOpen: (value: Date) => void;
    onValueChange: ({ from, to }: ValueChangeParams) => void;
    onError?: (error: Error) => void;
    onMonthChange?: React.Dispatch<React.SetStateAction<Date>>;
}

export interface CombinedDatePickerCallbackInterface {
    onClose?: () => void;
    onOpen: (value: Date) => void;
    onValueChange: ({ from, to }: ValueChangeCombinedParams) => void;
    onError?: (error: Error) => void;
    onMonthChange?: React.Dispatch<React.SetStateAction<Date>>;
}

export enum FormType {
    LastMinute = 'lastminute',
    AllInclusive = 'allinclusive',
    Package = 'package',
    EarlyBird = 'earlybird',
    Default = 'default',
}

export enum ActiveDatepicker {
    Departure = 'departure',
    Return = 'return',
    None = 'none',
}

export enum DatepickerType {
    Departure,
    Return,
    Combined,
    Split,
}

export interface ValueChangeParams {
    from: Date;
    to: Date;
}

export interface ValueChangeCombinedParams {
    from: Date;
    to?: Date;
}
